import { getApiErrorDetails, getApiErrorStatus } from "@/shared/helpers/errors";
import { CODE_LIMIT_COOLDOWN_SECONDS } from "./recovery-channels";

/**
 * Segundos para travar o reenvio depois de uma falha no envio de código.
 *
 * Só o 429 ("Muitas solicitações de código. Tente novamente mais tarde.")
 * trava: o back limita a 5 códigos por cliente por hora, e reenviar antes só
 * repete o erro. Usa `retryAfterSeconds` quando vier em `details`; senão a
 * espera padrão. Qualquer outro erro devolve 0 (pode tentar de novo já).
 */
export function codeResendHoldSeconds(error: unknown): number {
    if (getApiErrorStatus(error) !== 429) return 0;
    const retryAfter = getApiErrorDetails<{ retryAfterSeconds?: unknown }>(error)?.retryAfterSeconds;
    return typeof retryAfter === "number" && retryAfter > 0
        ? Math.ceil(retryAfter)
        : CODE_LIMIT_COOLDOWN_SECONDS;
}
